<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        星汉未来开源社区招募
      </a-typography-title>
      <a-typography-paragraph>
        致力于让计算像电一样随需使用，星汉未来开源社区是一个关于云原生算力治理的开放社区。<br>
        我们期待更多热衷于技术社区、有技术能力、乐于分享的伙伴们，与星汉未来共建云原生算力治理社区生态。
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="$Store.Page().openModal('modalQR','openSource')">
          立即加入
        </a-button>
        <a-button type="link" class="button_n_1"
                  target="_blank" :href="href.github">
          GitHub
        </a-button>
        <!--<a-button type="link" class="button_n_1"-->
        <!--          target="_blank" :href="href.document">-->
        <!--    开发者文档-->
        <!--</a-button>-->
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'community_banner',
  data(): DataInterface {
    return {
      href: {
        github: 'https://github.com/galaxy-future',
        document: ''
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 150px 0 80px;
    margin: 0 auto;
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 800px;
  margin: 20px 0 0;
  .font(left, 34px, @color_white, 18px);
}

.ant-space {
  margin: 20px 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  .button_n_1 {
    width: 100px !important;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>